import React from 'react';
import { Ionicons } from '@expo/vector-icons';
import { router } from 'expo-router';

import { ThemedText } from '@/components/themed-text';
import { PressableScale } from '@/components/ui/pressable-scale';
import { ShortcutWidgetData } from '@/types/assistant';
import { WidgetCard } from './widget-card';
import { WidgetProps } from './widget-types';

/**
 * O atalho para a tela certa (cenário 14).
 *
 * Aparece quando o pedido cai fora da fronteira do assistente — cobrança,
 * cliente, contrato, pagamento, assinatura. A recusa sem saída seria só um
 * "não"; com o atalho, o prestador continua resolvendo o problema dele, dois
 * toques depois.
 */
export function ShortcutWidget({ data }: WidgetProps<ShortcutWidgetData>) {
  return (
    <WidgetCard title="Isso fica com você" icon="open-outline">
      <PressableScale
        onPress={() => router.push(data.route as never)}
        className="flex-row items-center justify-center gap-2 rounded-full bg-neutral-100 py-2.5"
      >
        <ThemedText className="text-sm font-semibold text-primary">
          {data.label}
        </ThemedText>
        <Ionicons name="arrow-forward" size={15} color="#FD5001" />
      </PressableScale>
    </WidgetCard>
  );
}
